import { render, staticRenderFns } from "./UpdatePasswordForm.vue?vue&type=template&id=9d441b0e&"
import script from "./UpdatePasswordForm.vue?vue&type=script&lang=js&"
export * from "./UpdatePasswordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports